import * as React from "react";
import { inject, observer } from "mobx-react";
import Dropzone from "react-dropzone";
import { UncontrolledTooltip } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import * as moment from "moment";

import * as fileUtil from "../../common/Methods/FileUtil";
import { SimpleConfirmation } from "../common/SimpleConfirmAlert";

import { AttachmentLog, AttachmentFile } from "src/model/Attachment";

import { AttachmentLogEndpoints } from "src/endpoints/AttachmentLogEndpoints";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faCloudUploadAlt, faDownload } from "@fortawesome/free-solid-svg-icons";
import { successMessage, errorMessage } from "./Toast";

interface Props {
    attachmentLogEndpoints?: AttachmentLogEndpoints;
    isEditable?: boolean;
    extraClassName?: string;

    attachmentLog: AttachmentLog;
    onAddAttachment: (attachmentLogId: number, fileName: string, contentType: string, data: string) => Promise<any>;
    onDeleteAttachment: (fileId: number) => Promise<any>;

    title: string;
}

export interface State {
    name: string;
    type: string;
    file: File;
}

@inject("attachmentLogEndpoints")
@observer
export default class AttachmentLogPanel extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    addAttachment = async (file: File) => {
        const fileBase64 = await fileUtil.FileToBase64(file);

        try {
            await this.props.onAddAttachment(this.props.attachmentLog.id, file.name, file.type, fileBase64);
            successMessage(`${file.name} has been attached.`);
        } catch (error) {
            errorMessage(error);
        }
    };

    deleteAttachment = (file: AttachmentFile) => async (event: React.MouseEvent<any>) => {
        const goAhead = await SimpleConfirmation(`Are you sure you'd like to delete '${file.name}'?`);
        if (!goAhead) {
            return;
        }

        try {
            await this.props.onDeleteAttachment(file.id);
            successMessage(`${file.name} has been deleted.`);
        } catch (error) {
            errorMessage(error);
        }
    };

    getAttachment = (file: AttachmentFile) => async (event: React.MouseEvent<any>) => {
        event.preventDefault();
        try {
            const blob = await this.props.attachmentLogEndpoints!.getAttachment(file.id);
            fileUtil.DownloadBlob(file.name, blob);
        } catch (error) {
            errorMessage(error);
        }
    };

    render() {
        const columns = [
            {
                dataField: "name",
                text: "File Name"
            },
            {
                dataField: "dateUploaded",
                text: "Date Uploaded",
                formatter: (cellContent: any, row: any) => {
                    return <span>{`${moment(row.dateUploaded).format("YYYY-MM-DD hh:mm a")}`}</span>;
                }
            },
            {
                dataField: "id",
                text: "Actions",
                headerStyle: { width: "100px" },
                formatter: (cellContent: any, row: AttachmentFile) => {
                    return (
                        <>
                            <button
                                type="text"
                                className="btn btn-secondary btn-sm mr-2"
                                id={`tooltipDownload${row.id}`}
                                title="Download File"
                                onClick={this.getAttachment(row)}
                            >
                                <FontAwesomeIcon icon={faDownload} />
                            </button>
                            <UncontrolledTooltip placement="top" target={`tooltipDownload${row.id}`} delay={0} className="tooltipstrap">
                                Download File
                            </UncontrolledTooltip>

                            <button
                                type="text"
                                className="btn btn-secondary btn-sm"
                                id={`tooltipDelete${row.id}`}
                                title="Delete File"
                                onClick={this.deleteAttachment(row)}
                                disabled={!this.props.isEditable}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </button>
                            <UncontrolledTooltip placement="top" target={`tooltipDelete${row.id}`} delay={0} className="tooltipstrap">
                                Delete File
                            </UncontrolledTooltip>
                        </>
                    );
                }
            }
        ];

        return (
            <>
                <div className="card shadow mt-3">
                    <div className={"card-header" + " " + this.props.extraClassName}>{this.props.title} - Attach Files and Forms </div>
                    <div className="card-body">
                        <div className="form-row">
                            <div className="form-group col-sm-12 col-md-12">
                                <Dropzone
                                    onDrop={acceptedFiles => acceptedFiles.map(file => this.addAttachment(file))}
                                    multiple={false}
                                    disabled={!this.props.isEditable}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <section>
                                            <div {...getRootProps()} className="py-3 rounded attachmentLog">
                                                <input {...getInputProps()} />
                                                <p className="text-center text-secondary mb-1">
                                                    <FontAwesomeIcon icon={faCloudUploadAlt} size="3x" className="mt-2" style={{ opacity: 0.6 }} />
                                                </p>
                                                <p className="text-center text-secondary" style={{ opacity: 0.6 }}>
                                                    Drag &amp; drop here or click to upload files
                                                </p>
                                            </div>
                                        </section>
                                    )}
                                </Dropzone>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12 col-md-12 mt-3">
                                <BootstrapTable
                                    keyField={"id"}
                                    hover={true}
                                    bordered={false}
                                    bootstrap4={true}
                                    striped={true}
                                    columns={columns}
                                    //data={this.props.isEditable ? this.state.owners : horseForSale.owners}
                                    data={this.props.attachmentLog.files || []}
                                    noDataIndication={() => "No File Uploaded"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/AttachmentLogPanel.tsx